import React, { useState, useEffect, useRef, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { toast } from "react-toastify";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { AsyncPaginate } from 'react-select-async-paginate';
import * as XLSX from "xlsx-js-style";
import { useSelector } from "react-redux";
import { getUserName } from "../../../Redux/selecters";

const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const OutStandingReport = () => {
    const apiService = new LeaseApiService();
    const ITEMS_PER_PAGE = 100
    const gridRef = useRef();
    const username = useSelector(getUserName);
    const { currencyPrecision } = useCurrency();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [leaseList, setLeaseList] = useState([]);
    const [tanentList, setTanentList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [leaseTypeList, setLeaseTypeList] = useState([]);
    const [formData, setFormData] = useState({
        property: "",
        tenantId: "",
        tenantName: "",
        leaseNo: "",
        unitNo: "",
        from: "",
        to: "",
        leaseStart: false,
        leaseType: "",
        company: "",
        category: "",
        leasePM: "",
    })
    const decimalNumbers = currencyPrecision?.decimalNumbers ?? 3;

    const formatAmount = (value) => {
        const num = Number(value);

        if (isNaN(num)) return "";

        return num.toFixed(decimalNumbers);
    };

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };
    useEffect(() => {
        fetchDropdownData();

        const today = new Date();

        const fromDate = new Date(today);
        fromDate.setFullYear(today.getFullYear() - 5);

        const toDate = new Date(today);
        toDate.setFullYear(today.getFullYear() + 5);

        setFormData((prev) => ({
            ...prev,
            from: formatDate(fromDate),
            to: formatDate(toDate),
        }));
    }, []);
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRSearchLeaseNos,LRAgreeSearchCustomers,LRAgreeSearchCategoryMix,LRAgreeSearchCompany,LRAgreeSearchLeaseType');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            const addAllOption = (list) => [{ value: 'All', text: 'All' }, ...list || []];
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties);
            setLeaseList(addAllOption(res?.data?.dropdowns?.LeaseNo));
            setTanentList(addAllOption(res?.data?.dropdowns?.LRAgreeSearchCustomers));
            setCompanyList(addAllOption(res?.data?.dropdowns?.LRAgreeSearchCompany));
            setCategoryList(addAllOption(res?.data?.dropdowns?.LRAgreeSearchCategoryMix));
            setLeaseTypeList(addAllOption(res?.data?.dropdowns?.LRAgreeSearchLeaseType));

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setExportData(null)
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            // let pm = formData.leasePM.join("/")
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 50);
            params.append("leaseOutstandingRequest.FromDate", formData?.from || updatedValue);
            params.append("leaseOutstandingRequest.ToDate", formData?.to || todate);
            params.append("leaseOutstandingRequest.Property", formData?.property?.value?.value || "All");
            params.append("leaseOutstandingRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("leaseOutstandingRequest.Tenant", formData?.tenantId?.label || formData?.tenantName?.value?.value || "All");
            params.append("leaseOutstandingRequest.LeaseNo", formData?.leaseNo?.label || "All");
            params.append("leaseOutstandingRequest.FD", false);
            params.append("leaseOutstandingRequest.Company", formData?.company?.label || "All");
            params.append("leaseOutstandingRequest.Category", formData?.category?.label || "All");
            params.append("leaseOutstandingRequest.LeaseType", formData?.leaseType?.label || "All");
            params.append("leaseOutstandingRequest.Type", "All");
            params.append("leaseOutstandingRequest.Reason", "All");
            params.append(
                "leaseOutstandingRequest.Status",
                formData.leasePM?.length
                    ? formData.leasePM.join("|")
                    : "All"
            );
            const res = await apiService.getApiParamater("LEASE_OUTSTANDING_REPORT", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setRowData(result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData, formData.leasePM?.length ? formData.leasePM.join("|") : "All")
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const handleSearch = async (newPageNo = pagination?.currentPage) => {
        try {
            setExportData(null)
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            // let pm = formData.leasePM.join("/")
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", pageSize || 50);
            params.append("leaseOutstandingRequest.FromDate", formData?.from || updatedValue);
            params.append("leaseOutstandingRequest.ToDate", formData?.to || todate);
            params.append("leaseOutstandingRequest.Property", formData?.property?.value?.value || "All");
            params.append("leaseOutstandingRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("leaseOutstandingRequest.Tenant", formData?.tenantId?.label || formData?.tenantName?.value?.value || "All");
            params.append("leaseOutstandingRequest.LeaseNo", formData?.leaseNo?.label || "All");
            params.append("leaseOutstandingRequest.FD", false);
            params.append("leaseOutstandingRequest.Company", formData?.company?.label || "All");
            params.append("leaseOutstandingRequest.Category", formData?.category?.label || "All");
            params.append("leaseOutstandingRequest.LeaseType", formData?.leaseType?.label || "All");
            params.append("leaseOutstandingRequest.Type", "All");
            params.append("leaseOutstandingRequest.Reason", "All");
            params.append("leaseOutstandingRequest.Status", "Active");
            const res = await apiService.getApiParamater("LEASE_OUTSTANDING_REPORT", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setRowData(result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData, "Active")
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total, status = "All") => {
        try {

            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("leaseOutstandingRequest.FromDate", formData?.from || updatedValue);
            params.append("leaseOutstandingRequest.ToDate", formData?.to || todate);
            params.append("leaseOutstandingRequest.Property", formData?.property?.value?.value || "All");
            params.append("leaseOutstandingRequest.UnitNo", formData?.unitNo?.label || "All");
            params.append("leaseOutstandingRequest.Tenant", formData?.tenantId?.label || formData?.tenantName?.value?.value || "All");
            params.append("leaseOutstandingRequest.LeaseNo", formData?.leaseNo?.label || "All");
            params.append("leaseOutstandingRequest.FD", false);
            params.append("leaseOutstandingRequest.Company", formData?.company?.label || "All");
            params.append("leaseOutstandingRequest.Category", formData?.category?.label || "All");
            params.append("leaseOutstandingRequest.LeaseType", formData?.leaseType?.label || "All");
            params.append("leaseOutstandingRequest.Type", "All");
            params.append("leaseOutstandingRequest.Reason", "All");
            params.append("leaseOutstandingRequest.Status", status);
            const res = await apiService.getApiParamater("LEASE_OUTSTANDING_REPORT", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setExportData(result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const columnDefs = [
        {
            headerName: "Lease No",
            field: "lease_No",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 110,
            pinned: "left",
        },
        {
            headerName: "Property Name",
            field: "property_Name",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 180,
        },
        {
            headerName: "Unit",
            field: "unit_No",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 120,
        },
        {
            headerName: "Unit Class",
            field: "unitClass",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 110,
        },
        {
            headerName: "Status",
            field: "status",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 110,
        },
        {
            headerName: "Customer",
            field: "cust1_Name",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 190,
        },
        {
            headerName: "Contact No",
            field: "mainContactno",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 130,
        },
        {
            headerName: "Category Mix",
            field: "category",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 130,
        },

        // Monthly Rent
        {
            headerName: "Monthly Rent",
            field: "dewa",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 130,
            valueFormatter: (params) => formatAmount(params.value),
        },

        // Lease Start
        {
            headerName: "Lease Start (Move In)",
            field: "lease_Date",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 160,
        },

        // Security Deposit
        {
            headerName: "Security Deposit",
            field: "security_Deposit",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 140,
            valueFormatter: (params) => formatAmount(params.value),
        },

        // Security Deposit Paid
        {
            headerName: "Security Deposit Paid",
            field: "otherAmountPaid",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 165,
            valueFormatter: (params) => formatAmount(params.value),
        },

        // Rent Receivable
        {
            headerName: "Rent Receivable",
            field: "rentPerAnnum",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 150,
            valueFormatter: (params) => formatAmount(params.value),
        },

        // Cleared
        {
            headerName: "Cleared",
            field: "clearedAmt",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 120,
            valueFormatter: (params) => formatAmount(params.value),
        },

        // Non Cleared
        {
            headerName: "Non Cleared",
            field: "nonCleared",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 130,
            valueGetter: (params) =>
                Number(params.data?.totalAmountPaid || 0) -
                Number(params.data?.amountPaid || 0),
            valueFormatter: (params) => formatAmount(params.value),
        },

        // OutStanding
        {
            headerName: "OutStanding",
            field: "outStanding",
            filter: true,
            floatingFilter: true,
            suppressMovable: true,
            width: 130,
            valueGetter: (params) =>
                Number(params.data?.rentPerAnnum || 0) -
                Number(params.data?.totalAmountPaid || 0),
            valueFormatter: (params) => formatAmount(params.value),
        },

        // Days Outstanding
        {
            headerName: "Days Outstanding",
            field: "daysOutStanding",
            filter: "agNumberColumnFilter",
            floatingFilter: true,
            suppressMovable: true,
            width: 150,
            valueFormatter: (params) => Math.round(Number(params.value) || 0),
        },
    ];
    const handleClearFilters = () => {
        setUnitList([])
        setExportData([])
        setRowData([])
        const today = new Date();
        const fromDate = new Date(today);
        fromDate.setFullYear(today.getFullYear() - 5);
        const toDate = new Date(today);
        toDate.setFullYear(today.getFullYear() + 5);
        setFormData({
            property: "",
            tenantId: "",
            tenantName: "",
            leaseNo: "",
            unitNo: "",
            leaseStart: false,
            leaseType: "",
            company: "",
            category: "",
            leasePM: "",
            from: formatDate(fromDate),
            to: formatDate(toDate),
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const propertyValue = value?.value === 'All' ? null : value?.value;
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', propertyValue?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items || []);
            setFormData(prev => ({ ...prev, [name]: value }));
        } else if (name === "tenantId") {
            setFormData(prev => ({ ...prev, [name]: value, tenantName: { label: value?.value?.text, value: value?.value } }));
        } else if (name === "tenantName") {
            setFormData(prev => ({ ...prev, [name]: value, tenantId: { label: value?.value?.value, value: value?.value } }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const loadOptions = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.value })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const loadOptionsName = (search, loadedOptions, { page }) => {
        let filtered = tanentList;

        if (search) {
            filtered = tanentList.filter(tenant =>
                tenant.value.toLowerCase().includes(search.toLowerCase()) ||
                tenant.text.toLowerCase().includes(search.toLowerCase())
            );
        }

        const start = page * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;

        const optionsChunk = filtered.slice(start, end);

        return Promise.resolve({
            options: optionsChunk.map(tenant => ({ value: tenant, label: tenant.text })),
            hasMore: end < filtered.length,
            additional: { page: page + 1 }
        });
    }
    const normalizeValue = (value) =>
        value === 0 || value === "0" || value === null || value === undefined
            ? ""
            : value;

    const exportExcel = () => {
        if (!exportData?.length) return;

        const title = "LEASE OUTSTANDING REPORT";

        const decimalNumbers =
            currencyPrecision?.decimalNumbers ?? 3;

        const columns = [
            {
                header: "Lease No",
                value: (item) => item?.lease_No ?? "",
            },
            {
                header: "Property Name",
                value: (item) => item?.property_Name ?? "",
            },
            {
                header: "Unit",
                value: (item) => item?.unit_No ?? "",
            },
            {
                header: "Unit Class",
                value: (item) => item?.unitClass ?? "",
            },
            {
                header: "Status",
                value: (item) => item?.status ?? "",
            },
            {
                header: "Customer",
                value: (item) => item?.cust1_Name ?? "",
            },
            {
                header: "Contact No",
                value: (item) => item?.mainContactno ?? "",
            },
            {
                header: "Category Mix",
                value: (item) => item?.category ?? "",
            },
            {
                header: "Monthly Rent",
                value: (item) => Number(item?.dewa || 0),
                type: "number",
                align: "right",
            },
            {
                header: "Lease Start (Move In)",
                value: (item) => item?.lease_Date ?? "",
                align: "center",
            },
            {
                header: "Security Deposit",
                value: (item) =>
                    Number(item?.security_Deposit || 0),
                type: "number",
                align: "right",
            },
            {
                header: "Security Deposit Paid",
                value: (item) =>
                    Number(item?.otherAmountPaid || 0),
                type: "number",
                align: "right",
            },
            {
                header: "Rent Receivable",
                value: (item) =>
                    Number(item?.rentPerAnnum || 0),
                type: "number",
                align: "right",
            },
            {
                header: "Cleared",
                value: (item) =>
                    Number(item?.clearedAmt || 0),
                type: "number",
                align: "right",
            },
            {
                header: "Non Cleared",
                value: (item) =>
                    Number(item?.totalAmountPaid || 0) -
                    Number(item?.amountPaid || 0),
                type: "number",
                align: "right",
            },
            {
                header: "OutStanding",
                value: (item) =>
                    Number(item?.rentPerAnnum || 0) -
                    Number(item?.totalAmountPaid || 0),
                type: "number",
                align: "right",
            },
            {
                header: "Days Outstanding",
                value: (item) => Math.round(Number(item?.daysOutStanding || 0)),
                type: "integer",
                align: "right",
            },
        ];

        const dataRows = exportData.map((item) =>
            columns.map((col) => col.value(item))
        );

        // =========================
        // TOTALS
        // =========================

        const totalColumnHeaders = [
            "Security Deposit",
            "Security Deposit Paid",
            "Rent Receivable",
            "Cleared",
            "Non Cleared",
            "OutStanding",
            "Days Outstanding",
        ];

        const totalsRow = columns.map((col, index) => {
            if (index === 0) return "Total";
            if (totalColumnHeaders.includes(col.header)) {
                return exportData.reduce(
                    (sum, item) => sum + (Number(col.value(item)) || 0),
                    0
                );
            }
            return "";
        });

        const totalRecordsRow = columns.map((col, index) => {
            if (index === 0) return "Total Records";
            if (index === 1) return exportData.length;
            return "";
        });

        const worksheet = XLSX.utils.aoa_to_sheet([
            [title],
            columns.map((col) => col.header),
            ...dataRows,
            totalsRow,
            totalRecordsRow,
        ]);

        // =========================
        // MERGE TITLE
        // =========================

        worksheet["!merges"] = [
            {
                s: { r: 0, c: 0 },
                e: {
                    r: 0,
                    c: columns.length - 1,
                },
            },
        ];

        // =========================
        // COLUMN WIDTHS
        // =========================

        worksheet["!cols"] = columns.map((col, index) => {
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map((row) =>
                    String(row[index] ?? "").length
                ),
                String(totalsRow[index] ?? "").length,
                String(totalRecordsRow[index] ?? "").length
            );

            return {
                wch: Math.min(
                    Math.max(maxLength + 3, 12),
                    35
                ),
            };
        });

        // =========================
        // ROW HEIGHT
        // =========================

        worksheet["!rows"] = [
            { hpt: 28 }, // title
            { hpt: 30 }, // headers
        ];

        // =========================
        // FREEZE
        // =========================

        worksheet["!freeze"] = {
            ySplit: 2,
        };

        // =========================
        // BORDER
        // =========================

        const borderStyle = {
            top: {
                style: "thin",
                color: { rgb: "FFD9D9D9" },
            },
            bottom: {
                style: "thin",
                color: { rgb: "FFD9D9D9" },
            },
            left: {
                style: "thin",
                color: { rgb: "FFD9D9D9" },
            },
            right: {
                style: "thin",
                color: { rgb: "FFD9D9D9" },
            },
        };

        // =========================
        // TITLE
        // =========================

        const titleCell = worksheet["A1"];

        if (titleCell) {
            titleCell.s = {
                font: {
                    bold: true,
                    sz: 16,
                    color: {
                        rgb: "FFFFFFFF",
                    },
                },

                fill: {
                    fgColor: {
                        rgb: "FF6E5199",
                    },
                },

                alignment: {
                    horizontal: "left",
                    vertical: "center",
                },

                border: borderStyle,
            };
        }

        // =========================
        // HEADER
        // =========================

        columns.forEach((column, c) => {
            const cell =
                worksheet[
                XLSX.utils.encode_cell({
                    r: 1,
                    c,
                })
                ];

            if (!cell) return;

            cell.s = {
                font: {
                    bold: true,
                    sz: 10,
                    color: {
                        rgb: "FFFFFFFF",
                    },
                },

                fill: {
                    fgColor: {
                        rgb: "FF666666",
                    },
                },

                alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                },

                border: borderStyle,
            };
        });

        // =========================
        // DATA
        // =========================

        dataRows.forEach((row, r) => {
            columns.forEach((col, c) => {
                const cell =
                    worksheet[
                    XLSX.utils.encode_cell({
                        r: r + 2,
                        c,
                    })
                    ];

                if (!cell) return;

                cell.s = {
                    font: {
                        sz: 10,
                        color: {
                            rgb: "FF000000",
                        },
                    },

                    alignment: {
                        vertical: "center",
                        horizontal:
                            col.align || "left",
                    },

                    border: borderStyle,
                };

                // Amount columns
                if (col.type === "number") {
                    cell.t = "n";

                    cell.z =
                        `#,##0.${"0".repeat(
                            decimalNumbers
                        )}`;
                } else if (col.type === "integer") {
                    cell.t = "n";
                    cell.z = "#,##0";
                }
            });
        });

        // =========================
        // TOTALS ROW
        // =========================

        const totalsRowIndex = dataRows.length + 2;
        const totalRecordsRowIndex = totalsRowIndex + 1;

        columns.forEach((col, c) => {
            const cell =
                worksheet[
                XLSX.utils.encode_cell({
                    r: totalsRowIndex,
                    c,
                })
                ];

            if (!cell) return;

            cell.s = {
                font: {
                    bold: true,
                    sz: 10,
                    color: {
                        rgb: "FF000000",
                    },
                },

                fill: {
                    fgColor: {
                        rgb: "FFF0EDF5",
                    },
                },

                alignment: {
                    vertical: "center",
                    horizontal: col.align || "left",
                },

                border: borderStyle,
            };

            if (col.type === "number") {
                cell.t = "n";
                cell.z =
                    `#,##0.${"0".repeat(
                        decimalNumbers
                    )}`;
            } else if (col.type === "integer") {
                cell.t = "n";
                cell.z = "#,##0";
            }
        });

        columns.forEach((col, c) => {
            const cell =
                worksheet[
                XLSX.utils.encode_cell({
                    r: totalRecordsRowIndex,
                    c,
                })
                ];

            if (!cell) return;

            cell.s = {
                font: {
                    bold: true,
                    sz: 10,
                    color: {
                        rgb: "FF000000",
                    },
                },

                alignment: {
                    vertical: "center",
                    horizontal: c === 1 ? "left" : (col.align || "left"),
                },

                border: borderStyle,
            };

            if (c === 1) {
                cell.t = "n";
                cell.z = "#,##0";
            }
        });

        // =========================
        // WORKBOOK
        // =========================

        const workbook =
            XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Outstanding"
        );

        XLSX.writeFile(
            workbook,
            "Lease_Outstanding_Report.xlsx"
        );
    };
    const showExcel = () => {
        if (rowData?.length > 0) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const today = new Date();
            let todate = formatDate(today)
            const oneYearBack = new Date();
            oneYearBack.setFullYear(today.getFullYear() - 1);
            const updatedValue = typeof oneYearBack === 'string' ? oneYearBack : formatDate(oneYearBack);
            const fromDate = moment(formData?.from || updatedValue, "DD-MMM-YYYY").format("YYYY-MM-DD");
            const toDate = moment(formData?.to || todate, "DD-MMM-YYYY").format("YYYY-MM-DD");
            const newTab = window.open("", "_blank");

            if (!newTab) {
                alert("Please allow popups for this site.");
                return;
            }

            if (newTab) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "ReportName", value: "LEASEOUTSTANDINGREPORT" },
                    { name: "FromDate", value: fromDate },
                    { name: "ToDate", value: toDate },
                    { name: "PropertyNo", value: formData?.property?.value?.value || "ALL" },
                    { name: "UnitNo", value: formData?.unitNo?.label || "ALL" },
                    { name: "CustomerId", value: formData?.tenantId?.label || formData?.tenantName?.value?.value || "ALL" },
                    { name: "LeaseNo", value: formData?.leaseNo?.label || "ALL" },
                    { name: "IsFromDate", value: formData?.leaseStart || false },
                    { name: "Company", value: formData?.company?.label || "ALL" },
                    { name: "Category", value: formData?.category?.label || "ALL" },
                    { name: "LeaseType", value: formData?.leaseType?.label || "ALL" },
                    { name: "Type", value: "ALL" },
                    { name: "Reason", value: "ALL" },
                    { name: "UnitClass", value: "ALL" },
                    { name: "ChkAll", value: false },
                    { name: "StatusList", value: formData.leasePM?.length ? formData.leasePM.join("|") : "" },
                    { name: "GroupLease", value: false },
                    { name: "downloadType", value: "EXCEL" },
                    { name: "UserName", value: username },
                ];

                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        } else {
            toast.warning("No record found")
        }
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList
                                        ?.slice()
                                        ?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))
                                        ?.map(item => ({
                                            value: item,
                                            label: item.text,
                                        }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Tenant ID</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenantId}
                                    loadOptions={loadOptions}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenantId", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Tenant</label>
                                <AsyncPaginate
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": { backgroundColor: "#F5F5F5", color: "#000" }
                                        }),
                                    }}
                                    value={formData?.tenantName}
                                    loadOptions={loadOptionsName}
                                    onChange={(selectedOption) => handleDropDownChange({ name: "tenantName", value: selectedOption })}
                                    additional={{ page: 0 }}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit No </label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList
                                        ?.slice()
                                        ?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))
                                        ?.map(item => ({
                                            value: item,
                                            label: item.text,
                                        }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">From</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    todayButton="Today"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex gap-2">
                                <div className="d-flex">
                                    <label className="form-label w-0">To</label>
                                    <DatePicker
                                        selected={formData.to}
                                        onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                        todayButton="Today"
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="followtoCheck"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.leaseStart}
                                        onChange={(e) => setFormData(prev => ({ ...prev, leaseStart: e.target.checked }))}
                                    />
                                    <label className="form-check-label">Lease Start Date</label>
                                </div>
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Lease No</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leaseNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leaseNo', value: selectedOption })}
                                    options={leaseList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Company</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.company}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'company', value: selectedOption })}
                                    options={companyList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>

                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Category</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.category}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'category', value: selectedOption })}
                                    options={categoryList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Lease Type</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leaseType}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leaseType', value: selectedOption })}
                                    options={leaseTypeList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex center gap-3 mb-3">
                                {["Active", "Renewed", "Terminated"].map((label) => (
                                    <div className="form-check" key={label}>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={label}
                                            checked={formData.leasePM?.includes(label)}
                                            onChange={(e) => {
                                                const checked = e.target.checked;

                                                setFormData((prev) => ({
                                                    ...prev,
                                                    leasePM: checked
                                                        ? [...(prev.leasePM || []), label]
                                                        : (prev.leasePM || []).filter(
                                                            (item) => item !== label
                                                        ),
                                                }));
                                            }}
                                        />

                                        <label
                                            className="form-check-label"
                                            htmlFor={label}
                                        >
                                            {label}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <div className="d-flex mt-2 gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div
                                        onClick={() => getItems()}
                                        className="mainbtnGry flex-end gap-2 w-50"
                                    >
                                        <FaFileCircleExclamation
                                            color="#fff"
                                            className="center mt-2 mx-2"
                                        />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-content-between">
                            <h5 className="col mainInvHead">Lease Outstanding Report</h5>
                            {/* <button className="btn btn-primary" >
                                Export as PDF
                            </button> */}
                            <button style={{ cursor: exportData?.length > 0 ? 'pointer' : 'not-Allowed' }} className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                            <button className="btn btn-secondary" onClick={showExcel}>
                                Show Report
                            </button>
                        </div>

                        <div className="gridshad mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    getRowStyle={(params) => (params.node.rowIndex % 2 === 0 ? { background: "#F0EDF5" } : { background: "#fff" })}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={handleSearch}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default OutStandingReport;
